import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-cursos',
  templateUrl: './cursos.component.html',
  styleUrls: ['./cursos.component.scss'],
})
export class CursosComponent implements OnInit {
  @ViewChild('modalSouProfessor') modalProfessor: TemplateRef<any>;

  modalRef: BsModalRef;

  cursosLista = [
    {
      id: 1,
      imagem: '/assets/img/sem-imagem.png',
      nomeCurso: 'Curso de envidraçamento de sacada sem rolamento',
      notaAvaliacao: '4,5',
    },
    {
      id: 2,
      imagem: '/assets/img/sem-imagem.png',
      nomeCurso: 'Curso de envidraçamento de sacada sem rolamento',
      notaAvaliacao: '4,5',
    },
    {
      id: 3,
      imagem: '/assets/img/sem-imagem.png',
      nomeCurso: 'Curso de envidraçamento de sacada sem rolamento',
      notaAvaliacao: '4,5',
    },
  ];

  avaliacoesLista = [
    {
      id: 1,
      img: '/assets/img/peterson.png',
      cursoNome: 'Curso envidraçamento sacada s/ rolamento',
      autor: 'Fabio gomes',
      comentario:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris porttitoenim vitae                                tortor tempus placerat.',
      avaliacao: '4.4',
    },
    {
      id: 2,
      img: '/assets/img/peterson.png',
      cursoNome: 'Curso envidraçamento sacada s/ rolamento',
      autor: 'Fabio gomes',
      comentario:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris porttitoenim vitae                                tortor tempus placerat.',
      avaliacao: '4.4',
    },
    {
      id: 3,
      img: '/assets/img/peterson.png',
      cursoNome: 'Curso envidraçamento sacada s/ rolamento',
      autor: 'Fabio gomes',
      comentario:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris porttitoenim vitae                                tortor tempus placerat.',
      avaliacao: '4.4',
    },
  ];

  constructor(private modalService: BsModalService) {}

  abrirProfessor() {
    this.modalRef = this.modalService.show(this.modalProfessor, {
      class: 'modal-dialog-centered modal-lg',
      keyboard: false,
      ignoreBackdropClick: true,
    });
  }

  decline(): void {
    this.modalRef.hide();
  }

  ngOnInit(): void {}
}
